// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Path232Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 63 32"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M54.766 0v12.505h-.082c-1.641-1.82-3.692-2.453-6.072-2.453-4.874 0-8.546 3.198-9.835 7.426-1.47-4.659-5.26-7.513-10.88-7.513-4.566 0-8.17 1.977-10.051 5.2V11.16H8.41V6.812h10.296V0H0v30.558h8.41V17.712h8.384a11.77 11.77 0 00-.383 3.02c0 6.375 5.045 10.847 11.485 10.847 5.415 0 8.984-2.453 10.872-6.926H31.56c-.975 1.344-1.715 1.743-3.664 1.743-2.26 0-4.209-1.903-4.209-4.16h14.677c.636 5.064 4.723 9.43 10.331 9.43 2.42 0 4.634-1.148 5.989-3.087h.082v1.978h7.414V0h-7.414zM23.92 17.804c.468-1.941 2.028-3.21 3.975-3.21 2.144 0 3.624 1.23 4.014 3.21H23.92zm26.345 8.1c-2.733 0-4.431-2.457-4.431-5.023 0-2.742 1.477-5.38 4.431-5.38 3.063 0 4.284 2.638 4.284 5.38 0 2.601-1.294 5.024-4.284 5.024z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default Path232Icon
/* prettier-ignore-end */
